// extracted by mini-css-extract-plugin
module.exports = {"navbar":"_1aQEFB4BB0K1sMXIHqEV6S","logo":"_2BUTnJxTa3BH2_qOx_TQS3"};